// extracted by mini-css-extract-plugin
export default {"Progress":"Progress_Progress__sNiv+","line":"Progress_line__it3gx","line1":"Progress_line1__aVHo9","line2":"Progress_line2__14eZi"};